import React from 'react';
import glamorous, { Div } from 'glamorous';
import Glyph from 'app/components/commons/Glyph';

const SmallText = glamorous.span({
  fontSize: '0.75em',
  display: 'flex',
  textTransform: 'initial',
  marginTop: 2,
});

function FastForwardIcon({

}) {
  return (
    <Div display="flex">
      <Glyph icon="ios-fastforward" />
      <SmallText>8m</SmallText>
    </Div>
  );
}

export default FastForwardIcon;
